import {NextPage} from "next";
import Head from "next/head";
import {AffiliateDashboardView} from "../components/affiliate/AffiliateDashboardView";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";

const Affiliate: NextPage = () => {
  return <>
    <Head>
      <title>Affiliate Dashboard</title>
    </Head>
    <AffiliateDashboardView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate']),
    }
  }
});

export default Affiliate